/**
 * Component for single product page.
 * Play first video in gallery after user interacts with the page.
 * If there are more videos in the gallery, Mutation Observer tracks users actions and plays video
 * when slide with it is currently active.
 */
jQuery(document).ready(function () {
    let videos = document.querySelectorAll(".single-product__gallery-container video");

    const videoVolume = 0.7;

    if (videos.length > 0 && window.innerWidth >= 1024) {
        jQuery(window).bind("click keydown touch", detectInteraction);

        function detectInteraction(){
            jQuery(window).unbind("click keydown touch");

            if (document.querySelector(".slick-active video")) {
                videos[0].play();
                videos[0].volume = videoVolume;
            }
        }

        const targetNode = document.querySelector('.iconic-woothumbs-images');

        const observer = new MutationObserver(function (mutationsList, observer) {
            for (const mutation of mutationsList) {
                if (mutation.target.classList.contains('slick-slide') && mutation.target.querySelector('video')) {
                    if (mutation.target.classList.contains('slick-active')) {
                        setTimeout(() => {
                            mutation.target.querySelector('video').play();
                            mutation.target.querySelector('video').volume = videoVolume;
                        },200)
                    } else {
                        mutation.target.querySelector('video').pause();
                    }
                }
            }
        });

        const config = {attributes: true, attributeFilter: ['class'], subtree: true};

        observer.observe(targetNode, config);
    }
});